import { render, staticRenderFns } from "./threePlusColumnCard.vue?vue&type=template&id=b90f00e6&scoped=true"
import script from "./threePlusColumnCard.vue?vue&type=script&lang=js"
export * from "./threePlusColumnCard.vue?vue&type=script&lang=js"
import style0 from "./threePlusColumnCard.vue?vue&type=style&index=0&id=b90f00e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90f00e6",
  null
  
)

export default component.exports